
import { QueryParams } from "../../interfaces/common";
import { mapToBackendFieldName } from "../queryTransactionsHelpers";
import { getAdvancedParamValues } from "../getParamValues";

export const generateBatchPrintQueryParams = (orderBy, param, searchParams): QueryParams => {
    return [
        {
            "value": "[{\"ori\": \"ALL\",\"rfp\": [\"ALL\"]}]",
            "name": "ori_rfp_json"
        },
        {
            "value": "true", // 'true' or 'false'
            "name": "isAdmin"
        },
        {
            "value": mapToBackendFieldName(orderBy),
            "name": "orderBy"
        },
        {
            "value": "3650",
            "name": "days"
        },
        {
            "value": getAdvancedParamValues("firstName", searchParams),
            "name": "firstName"
        },
        {
            "value": getAdvancedParamValues("middleName", searchParams),
            "name": "middleName"
        },
        {
            "value": getAdvancedParamValues("lastName", searchParams),
            "name": "lastName"
        },
        {
            "value": getAdvancedParamValues("transactionNumber", searchParams),
            "name": "tcn"
        },
        {
            "value": getAdvancedParamValues("transactionType", searchParams),
            "name": "tot"
        },
        {
            "value": getAdvancedParamValues("reasonFingerprinted", searchParams),
            "name": "rfp"
        },
        {
            "value": getAdvancedParamValues("ori", searchParams),
            "name": "ori"
        },
        {
            "value": getAdvancedParamValues("secondaryOri", searchParams),
            "name": "secondaryOri"
        },
        {
            "value": param?.column === "transactionDate" ? getAdvancedParamValues("transactionDate", searchParams, "lowerDate") : getAdvancedParamValues("lowerDate", searchParams),
            "name": "lowerDate"
        },
        {
            "value": param?.column === "transactionDate" ? getAdvancedParamValues("transactionDate", searchParams, "upperDate") : getAdvancedParamValues("upperDate", searchParams),
            "name": "upperDate"
        },
        {
            "value": "null",
            "name": "printLocation"
        },
        {
            "value": "null",
            "name": "printlocation"
        },
        {
            "value": "P",
            "name": "resultsDistribution"
        },
        {
            "value": "null",
            "name": "cardType"
        },
        {
            "value": "null",
            "name": "fbiRapsheet"
        },
        {
            "value": "null",
            "name": "stateRapsheet"
        },
        {
            "value": getAdvancedParamValues("status", searchParams),
            "name": "transactionStatus"
        }
    ]
}